import { useEffect, useState, useMemo, useContext } from "react";
import { ArrowLeftIcon } from "../../../kits/Icons/Icons";
import defaultCoverProduct from "../../../../assets/images/defaultCover/defaultCoverProduct.png";
import ProductCard from "../../../common/ProductCard/ProductCard";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useParams, NavLink } from "react-router-dom";
import ColorSchema from "../../../../assets/kits/colors";
import ShoppingCartItemContext from "../../../../context/ShoppingCart/ShoppingCartItemContext";
import { pathMaker } from "../../../../utilities/helperFunctions";

export default function ProductScroll({
  title,
  hasMoreText,
  productList,
  shopIsOpen,
  setIsOpenDrawerClose,
  index,
  shopId,
}) {
  const { width, height } = useWindowSize();

  const productCardWidth = useMemo(() => {
    return width >= 445 ? 130 : width >= 375 ? 160 : 130;
  }, [width]);

  const {
    getItemCountPerShop,
    changeShoppingCartItemCount,
    shoppingListItemsFinalState,
  } = useContext(ShoppingCartItemContext);

  const shoppingCartState = shoppingListItemsFinalState;
  const count = getItemCountPerShop(shopId);
  return (
    <>
      {" "}
      <div className="mr-t-16">
        <div className="d-flex justify-content-between mr-b-12   ">
          <div className="title-h4-m mr-r-20">{title}</div>
          {hasMoreText ? (
            <NavLink
              to={`/filter-product/${shopId}/${title}/${index}`}
              className="text-decoration-none desc-l "
            >
              <div className="d-flex mr-l-14">
                <span
                  className="desc-l"
                  style={{ cursor: "pointer", color: ColorSchema.gray_600 }}
                >
                  مشاهده همه
                </span>
                <ArrowLeftIcon width={16} height={16} />
              </div>
            </NavLink>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="mr-r-14 pd-b-12 d-flex" style={{ overflowX: "auto" }}>
        {productList.map((value) => {
          return (
            <>
              {value.avb_pid_status == 0 &&
                value.product_status == 0 &&
                value.total_inventory_count != 0 && (
                  <div className="mr-x-6">
                    <ProductCard
                      // cartProps={(style = { {zIndex: 0} })}
                      title={value.title}
                      link={`/product/${shopId}/${value.avb_product_for_order__id}`}
                      price={value.price}
                      cartItemCount={
                        count[`apoId_${value.avb_product_for_order__id}`]
                      }
                      imagePath={pathMaker(value.imagePath)}
                      key={`product-card-${index}`}
                      disabled={!shopIsOpen}
                      discount={value.discount}
                      disableOnClick={() => {
                        if (!shopIsOpen) {
                          setIsOpenDrawerClose(true);
                        }
                      }}
                      plusOnClick={() => {
                        changeShoppingCartItemCount(
                          "add",
                          "",
                          value.total_inventory_count,
                          value.min_order_count,
                          getItemCountPerShop(shopId)[
                            `apoId_${value.avb_product_for_order__id}`
                          ],
                          "1",
                          value.price,
                          value.avb_product_for_order__id,
                          value.title,
                          shopId
                        );
                      }}
                      minusOnClick={() => {
                        changeShoppingCartItemCount(
                          "reduce",
                          "",
                          value.total_inventory_count,
                          value.min_order_count,
                          "",
                          "1",
                          value.price,
                          value.avb_product_for_order__id,
                          value.title,
                          shopId
                        );
                      }}
                      width={productCardWidth}
                      loading={
                        shoppingCartState[
                          `state-${value.avb_product_for_order__id}`
                        ] == true
                          ? true
                          : false
                      }
                    />
                  </div>
                )}
            </>
          );
        })}
      </div>
    </>
  );
}
